import { RNEvent } from './constants';
import { reactNativeWindow } from '../../utils/get-native-window';

export const onRN = (event: RNEvent, cb) => {
  if (!reactNativeWindow.messageEvents) {
    return;
  }
  reactNativeWindow.messageEvents[event] = cb;
};
